import axios from "axios";

const apiClient = () =>{
    
    // const {REACT_APP_BACKEND_OPS_API_URL} = process.env;

    const axiosInstance = axios.create(
        {
            baseURL:'/api',
            responseType:'json'
        }
    );

    return axiosInstance

}

export default apiClient;